import { Card, type CardProps } from "@clipboard-health/ui-components";
import { mergeSxProps } from "@clipboard-health/ui-components";

interface ShiftCardWrapperProps extends CardProps {
  isUrgent?: boolean;
  isBundle?: boolean;
}

export function ShiftCardWrapper(props: ShiftCardWrapperProps) {
  const {
    isUrgent = false,
    isBundle = false,
    variant = "quaternary",
    outlined = true,
    sx,
    ...restProps
  } = props;

  return (
    <Card
      variant={variant}
      outlined={isUrgent || isBundle || outlined}
      sx={mergeSxProps(
        (theme) => ({
          minHeight: theme.size?.shiftCard.minHeight,
          borderColor: (theme) => {
            if (isUrgent) {
              return theme.palette.shift?.urgent.border;
            }
            if (isBundle) {
              return theme.palette.shift?.bundle?.border;
            }
            return undefined;
          },
        }),
        sx
      )}
      {...restProps}
    />
  );
}
